import { Injectable, OnInit, Output, EventEmitter } from '@angular/core';
import { CLEANER } from './mock-users';
import { Http, Response, Headers, URLSearchParams, Jsonp} from '@angular/http';
import { Subject, Subscription } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import {AuthService} from "./auth.service";
import { Router } from "@angular/router";
import * as moment from 'moment';
import { LoaderService } from '../common/loadingBar/loader.service';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class ServiceService extends AuthService{
    private URLServiceId = "manager/service/:id";
    private URLAddComment = "manager/service/:id/comment";
    private URLAddCommentIncidence = "manager/service/:id/incidence-comment";
    private URLCancelService = "manager/service/:id/reason/:comment?allow_to_penalize=:penalize";
    private URLCancelAllServices = "manager/service/:id/all/reason/:comment?allow_to_penalize=:penalize";
    private URLEditClintuComment = "manager/service/:id/clintu-comment";
    private URLEditCleanerComment = "manager/service/:id/professional-comment";
    private URLUnAssignService = "manager/service/:id/assign";
    private URLAssignService = "manager/service/:id/assign";
    private URLGetOfficesFromUser = "api/v1/getOfficesFromUser/:id";
    private URLGetOfficeInfo = "api/v1/getOfficeInfo/:id";
    private URLUpdateOldService = "api/v1/editOldService/";
    private URLCreateProfComment = "manager/service/:id/professional-comment";
    private URLEditService = "manager/service/:id?allow_to_penalize=:penalize";
    private URLCreateService = "manager/service";
    private URLGetCleanersForAService = "manager/service/:id/available-cleaners";
    private URLGetCleanersAlphabetic = "manager/service/:id/available-cleaners/:letter/alphabetic";
    private URLAddDiscount = "manager/service/:id/discount";
    private URLCheckDiscount = "manager/service/check-discount/email/:mail/code/:code";
    private ID = ":id";
    private IDCLEANER = ":idCleaner";
    private LETTER = ":letter";
    private COMMENT = ":comment";
    private PENALIZE = ":penalize";
    private EMAIL = ":mail";
    private CODE = ":code";
    private PENALIZE_STR = "?allow_to_penalize=";
    private availability: Array<object> = [];

    constructor(public http: Http, public router: Router, private loaderService: LoaderService) {
        super(http, router);
    }

   public getServiceById(id: string) {
        this.loaderService.show();
        let URLServiceId = this.URLServiceId.replace(this.ID, id);
        return this.http.get(this.APIURL + URLServiceId ,{headers: this.headers})
        .map((res: Response) => {
            var data = this.parseService(res.json()["response"]);
            this.loaderService.hide();
            return data;
        });
   }

   public addServiceComment(id: string, data: object) {
        let URLAddComment = this.URLAddComment.replace(this.ID, id);
        return this.http.post(this.APIURL + URLAddComment , data, {headers: this.headers})
        .map((res: Response) => {
            return res.json()["response"];
        });
   }

   public addServiceCommentIncidence(id: string, data: object) {
        let URLAddCommentIncidence = this.URLAddCommentIncidence.replace(this.ID, id);
        return this.http.post(this.APIURL + URLAddCommentIncidence , data, {headers: this.headers})
        .map((res: Response) => {
            return res.json()["response"];
        });
   }

   public addProfComment(id: string, data: object){
        let URLCreateProfComment = this.URLCreateProfComment.replace(this.ID, id);
        return this.http.post(this.APIURL + URLCreateProfComment , data, {headers: this.headers})
        .map((res: Response) => {
            return res.json()["status"];
        });
   }

   public editCommentClintu(id: string, data: object) {
        let URLEditClintuComment = this.URLEditClintuComment.replace(this.ID, id);
        return this.http.put(this.APIURL + URLEditClintuComment , data, {headers: this.headers})
        .map((res: Response) => {
            return res.json()["status"];
        });
   }

   public editCommentCleaner(id: string, data: object) {
        let URLEditCleanerComment = this.URLEditCleanerComment.replace(this.ID, id);
        return this.http.put(this.APIURL + URLEditCleanerComment , data, {headers: this.headers})
        .map((res: Response) => {
            return res.json()["status"];
        });
   }

   public unAssignService(id: string, idCleaner: string) {
    this.loaderService.show();
       let URLUnAssignService = this.URLUnAssignService.replace(this.ID, id).replace(this.IDCLEANER,idCleaner);
        return this.http.delete(this.APIURL + URLUnAssignService ,{headers: this.headers})
        .map((res: Response) => {
            this.loaderService.hide();
            return res.json()["status"]
        });
   }

   public unAssignAllServices(data: object) {
    this.loaderService.show();
    let URLEditService = this.URLEditService.replace(this.ID, data["id"]);
     return this.http.delete(this.APIURL + URLEditService ,{headers: this.headers})
     .map((res: Response) => {
         this.loaderService.hide();
         return res.json()["status"]
     });
   }

   public assignService(id: string, idCleaner: string) {
        var data = {
            serviceId: id,
            professionalId: idCleaner
        }
        this.loaderService.show();
        let URLAssignService = this.URLAssignService.replace(this.ID, id);
        return this.http.post(this.APIURL + URLAssignService, data, {headers: this.headers})
        .map((res: Response) => {
            this.loaderService.hide();
            return res.json()["status"]
        });
   }

   public cancelService(id: string, reason: string, penalize: string) {
        this.loaderService.show();
        let URLCancelService;
        if(penalize != null) {
            URLCancelService = this.URLCancelService.replace(this.ID, id).replace(this.COMMENT, reason).replace(this.PENALIZE, penalize);
        }else{
            URLCancelService = this.URLCancelService.replace(this.ID, id).replace(this.COMMENT, reason).replace(this.PENALIZE_STR, '').replace(this.PENALIZE, '');
        }
        return this.http.delete(this.APIURL + URLCancelService,{headers: this.headers})
        .map((res: Response) => {
            this.loaderService.hide();
            return res.json()["status"]
        });
   }

   public editService(id: string,data: object, penalize: string) {
        this.loaderService.show();
        let URLEditService;
        if(penalize != null) {
            URLEditService = this.URLEditService.replace(this.ID, id).replace(this.PENALIZE, penalize);
        }else{
            URLEditService = this.URLEditService.replace(this.ID, id).replace(this.PENALIZE_STR, '').replace(this.PENALIZE, '');
        }
        return this.http.put(this.APIURL + URLEditService,data, {headers: this.headers})
        .map((res: Response) => {
            this.loaderService.hide();
            return res.json();
        });
   }

   public cancelAllServices(id: string, reason: string, penalize: string) {
        this.loaderService.show();
        let URLCancelAllServices;
        if(penalize != null) {
            URLCancelAllServices = this.URLCancelAllServices.replace(this.ID, id).replace(this.COMMENT, reason).replace(this.PENALIZE, penalize);
        }else{
            URLCancelAllServices = this.URLCancelAllServices.replace(this.ID, id).replace(this.COMMENT, reason).replace(this.PENALIZE_STR, '').replace(this.PENALIZE, '');
        }
        return this.http.delete(this.APIURL + URLCancelAllServices ,{headers: this.headers})
        .map((res: Response) => {
            this.loaderService.hide();
            return res.json()["status"]
        });
   }

   public getOfficesFromUser(id: string) {
       let URLGetOfficesFromUser = this.URLGetOfficesFromUser.replace(this.ID, id);
        return this.http.get(this.APIURL + URLGetOfficesFromUser ,{headers: this.headers})
        .map((res: Response) => res.json()["data"]);
   }

   public createService(data: object){
       return this.http.post(this.APIURL + this.URLCreateService , data, {headers: this.headers})
        .map((res: Response) => {
            //console.log(res);
            return res.json()["data"]
        });
   }

   public addDiscount(id: string, data: object) {
        let URLAddDiscount = this.URLAddDiscount.replace(this.ID, id);
        return this.http.post(this.APIURL + URLAddDiscount , data, {headers: this.headers})
        .map((res: Response) => res.json()["status"]);
   }

   public checkDiscount(mail: string, code: string) {
        let URLCheckDiscount = this.URLCheckDiscount.replace(this.EMAIL, mail).replace(this.CODE, code);
        return this.http.get(this.APIURL + URLCheckDiscount ,{headers: this.headers})
        .map((res: Response) => res.json());
    }

   public getCleanerForService(id: string, selection: object){
        this.loaderService.show();
        let URLGetCleanersForAService = this.URLGetCleanersForAService.replace(this.ID, id);
        return this.http.get(this.APIURL + URLGetCleanersForAService ,{headers: this.headers})
        .map((res: Response) => {
            this.loaderService.hide();
            return res.json()["response"]
        })
        .filter(data => {
            this.parseAvailability(data, selection);
            return true;
        });
   }

   public getCleanersAlphabetic(id: string, selection: object, letter: string){
        let URLGetCleanersAlphabetic = this.URLGetCleanersAlphabetic.replace(this.ID, id).replace(this.LETTER, letter);
        return this.http.get(this.APIURL + URLGetCleanersAlphabetic ,{headers: this.headers})
        .map((res: Response) => res.json()["response"])
        .filter(data => {
            this.parseAvailability(data, selection);
            return true;
        });
    }

   private parseService(service) {
        /*var integer = parseInt(service["service"]["n_hours"]);
        var decimals = service["service"]["n_hours"] - integer;
        var minutes = (decimals == 0) ? ":00" : ":30";*/
        service["service"]["n_hours"] = parseFloat(service["service"]["n_hours"]);
        var dateParsed = service["service"]["date"];
        service["service"]["today"] = moment().format("YYYY-MM-DD");
        service["service"]["date"] = moment(service["service"]["date"]).format("DD/MM/YYYY");
        service["service"]["isAfter"] = moment(dateParsed).isAfter(service["service"]["today"]);
        service["service"]["isSame"] = moment(dateParsed).isSame(service["service"]["today"]);
        service["service"]["isBefore"] = moment(dateParsed).isBefore(service["service"]["today"]);
        return service;
   }

   private parseAvailability(data, objectSelection){
        this.availability = data;
        let selection = false, counter = 0, i= 0, n_elements;
        let indexRemoveArray = [];
        objectSelection["time_ini"] = moment(objectSelection["time_ini"],"H:mm").format("HH:mm");
        for(let cleaner of this.availability){
            
            var cleaner_name = cleaner["cleaner_name"].split(" ");
            var cleaner_name_length = cleaner_name.length;
            cleaner["cleaner_full_name"] = cleaner["cleaner_name"];
            if(cleaner_name_length < 3){
                //cleaner["cleaner_name"] = cleaner_name[0] + " " + cleaner_name[1].charAt(0).toUpperCase() + cleaner_name[1].charAt(1) + cleaner_name[1].charAt(2) + ".";
                cleaner["cleaner_name"] = cleaner["cleanerName"] + " " + cleaner["cleanerSurname"].charAt(0).toUpperCase() + ".";
            }else{
                cleaner["cleaner_name"] = cleaner["cleanerName"] + " " + cleaner["cleanerSurname"].charAt(0).toUpperCase() + ".";
                //cleaner["cleaner_name"] = cleaner_name[0] + " " + cleaner_name[2].charAt(0).toUpperCase() + cleaner_name[2].charAt(1) + cleaner_name[2].charAt(2) + ".";
            }
            cleaner["cleaner_name_abrv"] = cleaner_name[0];
            if(cleaner["day_summary"] != null && cleaner["day_summary"].split('').length > 0){
                var hours = cleaner["day_summary"].match(/.{1,6}/g);
                this.availability[i]["hours"] = [];
                var j = 0;
                var time_ini = moment();
                var time_end = null;
                time_ini.hours(8).minutes(0);
                selection = false;
                counter = 0;
                let duration = parseFloat(objectSelection["n_hours"]);
                for(let hour of hours){
                    var isFree = new RegExp('^[E]*$');
                    var isBusy = new RegExp('[B]');
                    var isNotAvailable = new RegExp('[X]');
                    var h = { available: null, time: null, duration: null };
                    
                    h["time"] = time_ini.format("HH:mm");
                    if(h["time"] == objectSelection["time_ini"]){
                        time_end = time_ini.add(duration,"hours").format("HH:mm");
                        n_elements = (duration * 2);
                    }
                    
                    if(!selection){
                        if(isFree.test(hour) && time_end == null) {
                            h["available"] = "available";
                            this.availability[i]["hours"].push(h);  
                        }
                        else if(isBusy.test(hour)) {
                            h["available"] = "busy";
                            this.availability[i]["hours"].push(h);  
                        }
                        else if(isNotAvailable.test(hour)) {
                            
                            h["available"] = "notAvailable";
                            this.availability[i]["hours"].push(h);  
                        }
                        else if(time_end != null){
                            h["available"] = "selection";
                            h["duration"] = (duration * 2) + 1;
                            
                            this.availability[i]["hours"].push(h);
                            selection = true;
                            time_end = null;
                            counter++;
                        }
                    }else{
                        counter++;
                        if(counter > n_elements){
                            selection = false;
                        }
                    }
                
                    j++;
                    time_ini.add(30,"minutes");
                }
            }else{
                indexRemoveArray.push(i);
            }
            i++;
        }

        indexRemoveArray.forEach(index => {
            this.availability.splice(index,1);
        })
    }

}


// WEBPACK FOOTER //
// ./src/app/injections/service.service.ts